import React from "react";
import { Flex, ButtonGroup, Button, Heading, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";

import Layout from "./Layout";
import { t } from "@lang/i18n";

const NotMatch = () => {
  return (
    <Layout minH="100%" w="100%">
      <Flex flexDir="column"
        justifyContent="space-between"
        alignItems="center"
        p="1rem 2rem"
        h="15rem"
        textAlign="center"
        mt="10%"
      >
        <Heading as="h1" fontSize="48px">
          404 Not Found
        </Heading>
        <Text fontSize="22px" fontWeight="600" mt={{ base: "2rem", md: "0" }}>
          { t('not_found.description') }
        </Text>

        <ButtonGroup
          variant="outline"
          spacing={{ base: "0", md: "8" }}
          display="flex"
          justifyContent={{ base: "space-between", md: "" }}
          flexDir={{ base: "column", md: "row" }}
          mt={{ base: "2rem", md: "0" }}
        >
          <Link to="/">
            <Button
              bg="gradient"
              textColor="white"
              p="0.5rem"
              w="10rem"
              borderRadius="20px"
              fontWeight="700"
              textDecoration="none !important"
              _hover={{ filter: "contrast(1.2)" }}
              _active={{ filter: "contrast(1.2)" }}
            >
              { t('not_found.home') }
            </Button>
          </Link>

          <Link to="/login">
            <Button
              mt={{ base: ".5rem", md: "0" }}
              bg="white"
              textColor="black"
              p="0.5rem"
              w="10rem"
              borderRadius="20px"
              fontWeight="700"
              _hover={{ opacity: ".8" }}
              _active={{ opacity: ".8" }}
            >
              { t('not_found.login') }
            </Button>
          </Link>
        </ButtonGroup>
      </Flex>
    </Layout>
  );
};

export default NotMatch;
